import React from 'react'
import { Table } from '@scuf/common'

const ConoDomo2 = ({ datos }) => {

    const tableGeneral = () => {
        let headerTable = ['Mineral', 'Porcentaje']
        // let contentTable = [
        //     { mineral: 'CALCOPIRITA', percetage: 3, masa: 4, angulo: 10 },
        //     { mineral: 'CALCOSINA', percetage: 3, masa: 4, angulo: 10 },
        //     { mineral: 'TENANTITA', percetage: 3, masa: 4, angulo: 10 },
        //     { mineral: 'BORNITA', percetage: 3, masa: 4, angulo: 10 },
        //     { mineral: 'ENARGITA', percetage: 3, masa: 4, angulo: 10 },
        //     { mineral: 'PIRITA', percetage: 3, masa: 4, angulo: 10 },
        //     { mineral: 'GALENA', percetage: 3, masa: 4, angulo: 10 },
        //     { mineral: 'ESFALERITA', percetage: 3, masa: 4, angulo: 10 },
        //     { mineral: 'HEMATITA', percetage: 3, masa: 4, angulo: 10 },
        //     { mineral: 'GANGA', percetage: 3, masa: 4, angulo: 10 }
        // ]

        return <>
            <Table>
                <Table.Header>
                    <Table.HeaderCell content='Ángulo' />
                    <Table.HeaderCell content='Masa' />
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>
                            {datos[0].Angulo} °
                        </Table.Cell>
                        <Table.Cell>
                            {datos[0].Masa} Ton
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            <Table>
                <Table.Header>
                    {headerTable.map(x => <Table.HeaderCell content={x} />)}
                </Table.Header>
                <Table.Body>
                    {
                        datos.map((x, i) =>
                            <Table.Row>
                                <Table.Cell>
                                    {x.Mineral} Ton
                                </Table.Cell>
                                <Table.Cell>
                                    {x.Porcentaje} %
                                </Table.Cell>
                            </Table.Row>
                        )
                    }
                </Table.Body>
            </Table>
        </>
    }

    return (
        <>
            {tableGeneral()}
        </>
    )
}

export default ConoDomo2
